import { BaseModel, type RelationConfig } from './base';

import { Customer } from './customer';

// Main Model

export class Review extends BaseModel {
  idLocationReview!: number;
  customer!: Customer | null;

  static override relations(): RelationConfig {
    return {
      customer: { type: Customer },
    };
  }

  override objectID(): string | null {
    return this.idLocationReview?.toString() ?? null;
  }
}
